import axios from '../utils/axios'

// 获取分享图片地址
export function GetShareImage(params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendQRCodeNew',
    method: 'get',
    params: params
  })
}

// 商品页分享图片地址
export function GetShareGoodsImage(params = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendProduct',
    method: 'get',
    params: params
  })
}

// 获取分享图片地址
export function RecommendQRCodeFrontEndConvertLink(data = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendQRCodeFrontEndConvertLink',
    method: 'post',
    data
  })
}

// 商品页分享图片地址
export function RecommendProductFrontEndConvertLink(data = {}) {
  return axios({
    url: '/Member/RecommendCycle/RecommendProductFrontEndConvertLink',
    method: 'post',
    data
  })
}
